import orderflowHelper from '@/config/order'
export let filterFactor = [{
  label: '待处理操作',
  type: 'select',
  clearable: true,
  value: 'orderActions', // 需返回数据的字段名
  options: getLabStatusOptions()
}]
export let filterFactorCopy = [{
  label: '已处理操作',
  type: 'select',
  clearable: true,
  value: 'orderActions', // 需返回数据的字段名
  options: getLabStatusOptions()
}]
// 原因应该用的 orderActionData.message 然后结果 用的是orderActionData.statusDetail.reason
export let tableLabels = [{
  label: '样本条码号',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '受检人',
  value: 'orderActionData.order.patient.name'
}, {
  label: '检测套餐',
  value: 'orderActionData.order.detectionPackageNames[0]'
}, {
  label: '实验室检测平台',
  value: 'orderActionData.order.product.name',
  minWidth: '120'
}, {
  label: '样本类型',
  value: 'orderActionData.order.currentSample.sampleType'
}, {
  label: '采集次数',
  value: 'orderActionData.order.collectTimesCopy'
}, {
  label: '待处理操作', // 下一状态
  value: 'orderActionData.nextAction',
  minWidth: '100'
}, {
  label: '处理原因',
  value: 'reason'
}, {
  label: '提交时间',
  value: 'createdDate',
  minWidth: '100'
}]

export let tableLabelsOk = [{
  label: '样本条码号',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '受检人',
  value: 'orderActionData.order.patient.name'
}, {
  label: '检测套餐',
  value: 'orderActionData.order.detectionPackageNames[0]'
}, {
  label: '实验室检测平台',
  value: 'orderActionData.order.product.name',
  minWidth: '120'
}, {
  label: '样本类型',
  value: 'orderActionData.order.currentSample.sampleType'
}, {
  label: '采集次数',
  value: 'orderActionData.order.collectTimesCopy'
}, {
  label: '已处理操作', // 下一状态
  value: 'orderActionData.nextAction',
  minWidth: '100'
}, {
  label: '处理原因',
  value: 'reason'
}, {
  label: '提交时间',
  value: 'createdDate',
  minWidth: '100'
}, {
  label: '处理结果',
  value: 'result',
  minWidth: '100'
}]
function getLabStatusOptions () {
  let options = []
  orderflowHelper.getDefaultOrderFlow().forEach(item => {
    if (item.name !== 'CREATED' && item.name !== 'COMPLETED' && item.name !== 'CLOSED' && item.name !== 'LAB_SAMPLE_RETURNED') {
      let signalItem = {
        label: item.operation,
        value: item.name
      }
      options.push(signalItem)
    }
  })
  return options
}
